import { useTranslation } from "react-i18next"
import { Dialog, DialogContentCustom, DialogHeader, DialogTitle } from "@/components/ui/dialog"

type BetterDocUsageFailureDialogProps = {
  open: boolean
  onClose: () => void
}

export const BetterDocUsageFailureDialog = ({ open, onClose }: BetterDocUsageFailureDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContentCustom
        variant="small"
        onPointerDownOutside={(event) => event.preventDefault()}
        data-testid="better-doc-usage-failure-dialog-content"
        className="max-w-md flex-col">
        <DialogHeader>
          <DialogTitle data-testid="better-doc-usage-failure-dialog-title">
            {t("episodeOfCare.betterDoc.usageFailureDialogTitle")}
          </DialogTitle>
        </DialogHeader>
        <p
          className="text-on-surface-subdued mx-6 mt-2 mb-6 text-sm"
          data-testid="better-doc-usage-failure-dialog-message">
          {t("episodeOfCare.betterDoc.usageFailureDialogMessage")}
        </p>
      </DialogContentCustom>
    </Dialog>
  )
}
